import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getVendors} from 'src/openapi/admin/apis/VendorManagementApi';
import {useAppDispatch} from 'src/store';

import type {Error as ApiError} from 'src/openapi/admin/models/Error';
import type {Vendor} from 'src/openapi/admin/models/Vendor';

type Return = {
    vendors: Vendor[],
    loading: boolean,
    error: ApiError | null,
    reload: () => Promise<void>,
};

export const useVendors = (shouldLoad = true): Return => {
    const dispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => {
        return dispatch(getVendors({signal}));
    }, [dispatch]);

    const {
        data: vendors,
        isLoading: loading,
        loadingError: error,
        loadData,
    } = useReadOnlyDataHook({
        initValue: [] as Vendor[],
        getDispatchAction,
        shouldLoadData: shouldLoad,
    });
    return {vendors, loading, error, reload: loadData};
};
